export const STRING_MIN_LENGTH = 1;
export const SHORT_STRING_MAX_LENGTH = 191;
export const PASSWORD_MIN_LENGTH = 8;
export const PASSWORD_MAX_LENGTH = 64;
export const MAX_FILE_SIZE_IN_MB = 5;
export const MIN_PACKAGE_PURCHASE = 1;
export const MAX_PACKAGE_PURCHASE = 10;
export const MIN_ASSIGNABLE_HOURS = 1;
export const MIN_ASSIGNABLE_CREDITS = 10;
